import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import SearchBar from "../../components/Common/SearchBar";
import Pagination from "../../components/Common/Pagination";
import RFQTable from "../../components/AdminDashboard/Requirements/RFQTable";
import { useRFQData } from "../../components/BuyerDashboard/Requirements/useRFQData";
import MultiSelectFilter from "../../components/Common/MultiSelectFilter";

export default function Requirements() {
  const [search, setSearch] = useState("");
  const [statusFilter, setStatusFilter] = useState(["All"]);
  const [perPage, setPerPage] = useState(5);
  const [currentPage, setCurrentPage] = useState(1);

  const {
    loading,
    requirements,
    totalPages,
    totalResults,
    availableStatuses,
    selectedRows,
    toggleAll,
    toggleRow,
    formatDate,
  } = useRFQData(search, currentPage, perPage, statusFilter);

  const statusOptions = ["All", ...availableStatuses];

  return (
    <div className="container mt-4 border rounded p-3">
      {/* Header */}
      <div className="d-flex justify-content-between align-items-center mb-1 flex-wrap gap-2">
        <h4 className="fw-bold">Requirements Overview</h4>
      </div>
      <p className="text-muted mb-2">
        Track, manage, and execute requirements with clarity and control
      </p>

      <div className="container mt-4 border rounded p-3">

        {/* Header */}
        <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap gap-2">
          <h5 className="fw-bold">Requirements</h5>
          <div className="d-flex gap-2 flex-wrap align-items-center">
            <MultiSelectFilter
              options={statusOptions}
              selectedValues={statusFilter}
              onChange={setStatusFilter}
              label="Status"
            />
            <SearchBar
              search={search}
              setSearch={setSearch}
              setCurrentPage={setCurrentPage}
            />
          </div>
        </div>

        {/* Table */}
        <RFQTable
          loading={loading}
          data={requirements}
          currentPage={currentPage}
          perPage={perPage}
          selectedRows={selectedRows}
          toggleRow={toggleRow}
          toggleAll={toggleAll}
          formatDate={formatDate}
        />

        {/* Pagination */}
        <Pagination
          perPage={perPage}
          setPerPage={setPerPage}
          setCurrentPage={setCurrentPage}
          currentPage={currentPage}
          totalPages={totalPages}
          totalResults={totalResults}
        />
      </div>
    </div >
  );
}